var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { FormatterHelper } from "../../../../../helpers/numbers-helper";
var SweepstakeWinningClaimBasicMeta = /** @class */ (function (_super) {
    __extends(SweepstakeWinningClaimBasicMeta, _super);
    function SweepstakeWinningClaimBasicMeta(notificationService, i18N, tokenClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        return _this;
    }
    SweepstakeWinningClaimBasicMeta.prototype.activate = function (model) {
        return _super.prototype.activate.call(this, model.item);
    };
    SweepstakeWinningClaimBasicMeta.prototype.isAdmin = function () {
        return this.tokenClient.isSuperAdmin();
    };
    SweepstakeWinningClaimBasicMeta.prototype.isOperatorAdmin = function () {
        return this.tokenClient.isOperatorAdmin() || this.tokenClient.isBrandAdmin();
    };
    SweepstakeWinningClaimBasicMeta.prototype.isInsurer = function () {
        return this.tokenClient.user.userId == this.item.insurerUserId;
    };
    SweepstakeWinningClaimBasicMeta.prototype.formatNumber = function (value) {
        return FormatterHelper.getformattedValue(Number(value), navigator.language, 2);
    };
    Object.defineProperty(SweepstakeWinningClaimBasicMeta.prototype, "winningAmountToClaim", {
        get: function () {
            if (this.item.insurerWinningAmountToClaim && this.item.insurerWinningAmountToClaim != this.item.systemWinningAmountToClaim)
                return this.formatNumber(this.item.systemWinningAmountToClaim) + ' >> (' + this.formatNumber(this.item.insurerWinningAmountToClaim) + ')';
            return this.formatNumber(this.item.systemWinningAmountToClaim);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeWinningClaimBasicMeta.prototype, "euroRate", {
        get: function () {
            if (this.item.insurerEuroRate && this.item.insurerEuroRate != this.item.systemEuroRate)
                return this.item.systemEuroRate + ' >> (' + this.item.insurerEuroRate + ')';
            return this.item.systemEuroRate;
        },
        enumerable: false,
        configurable: true
    });
    SweepstakeWinningClaimBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, TokenClient])
    ], SweepstakeWinningClaimBasicMeta);
    return SweepstakeWinningClaimBasicMeta;
}(ChildComponent));
export { SweepstakeWinningClaimBasicMeta };
